import React from 'react';
import { motion } from 'framer-motion';
import { CountdownBar } from './CountdownBar';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToCategories = () => {
    document.getElementById('categorias')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const marqueeText = 'Anime • Videojuegos • Marcas • Artistas • Tendencias • Brainrot • Marvel • DC • Series • Fórmula 1 • Autos • K-Pop • Religión • Dúos • Funkos • Rock • Fantasía • Acción • ¡Y mucho más! • ';
  return <section className="relative flex flex-col items-center overflow-hidden" data-id="element-75">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 opacity-[0.65] bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/7rnUTjsFQDLxvyqUjbmsHy/ChatGPT_Image_4_mar_2026,_20_53_13.png")'
    }} data-id="element-76" />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#0a0e1a]/70 via-[#0a0e1a]/85 to-[#0a0e1a]" data-id="element-77" />

      {/* Marquee */}
      <div className="w-full overflow-hidden bg-[#f5a623] text-black py-1.5 z-20 font-bold text-xs md:text-sm whitespace-nowrap relative" data-id="element-78">
        <div className="inline-block animate-marquee-fast" data-id="element-79">
          {marqueeText}
          {marqueeText}
          {marqueeText}
        </div>
      </div>

      {/* Countdown Bar */}
      <CountdownBar data-id="element-80" />

      <div className="max-w-[980px] mx-auto px-4 relative z-10 flex flex-col items-center text-center pt-6 pb-8 md:pt-10 md:pb-12" data-id="element-81">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[24px] md:text-[38px] font-black text-white mb-4 md:mb-5 leading-[1.1] max-w-3xl uppercase" data-id="element-82">
          Un año de diseños resueltos y probados para que tu marca sea{' '}
          <span className="text-[#f5a623] text-glow" data-id="element-83">viral</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full max-w-[280px] md:max-w-[420px] mb-4 md:mb-5 cursor-pointer" onClick={scrollToPricing} data-id="element-84">
          <img src="https://cdn.magicpatterns.com/uploads/2B3MUdaj93husP8nn4K8yi/36e470ec-59f9-4002-91d2-d34c7d9c32eb.png" alt="Kit Viral Sublimación & DTF Mockup" className="w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-500" data-id="element-85" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-[14px] md:text-lg text-gray-300 mb-5 md:mb-6 font-medium max-w-xl" data-id="element-86">
          Accedé a +500.000 diseños listos para sublimar y empezá mañana mismo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center gap-3" data-id="element-87">
          <button onClick={scrollToPricing} className="btn-primary !px-6 !py-3 !text-sm md:!text-base" data-id="element-88">
            SÍ, QUIERO EL KIT AHORA
          </button>
          <button onClick={scrollToCategories} className="text-gray-400 hover:text-[#f5a623] transition-colors font-medium text-[13px] md:text-[15px] flex items-center gap-1" data-id="element-89">
            Más información ↓
          </button>
        </motion.div>
      </div>
    </section>;
}